import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
var _excluded = ["children", "mobileFullScreen", "isOpen", "onBackdropClick", "theme", "onClick"];
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import Portal from './Portal';
import CloseIcon from '../Icons/CloseIcon';
import withTheme from '../theme/withTheme';
import { ModalGlobalStyles, Backdrop, ModalContainer, CloseButton } from './styles';
var _ref = /*#__PURE__*/React.createElement(ModalGlobalStyles, null);
var Modal = /*#__PURE__*/function (_React$Component) {
  _inherits(Modal, _React$Component);
  var _super = _createSuper(Modal);
  function Modal(props) {
    var _this;
    _classCallCheck(this, Modal);
    _this = _super.call(this, props);
    _this.state = {
      renderPortal: false
    };
    return _this;
  }
  _createClass(Modal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var isOpen = this.props.isOpen;
      if (isOpen && !prevProps.isOpen) {
        this.onModalOpen();
      } else if (!isOpen && prevProps.isOpen) {
        this.onModalClose();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeBodyOverflow();
    }
  }, {
    key: "onModalOpen",
    value: function onModalOpen() {
      var _this2 = this;
      var onBackdropClick = this.props.onBackdropClick;
      this.createModalDiv();
      var body = document.querySelector('body');
      body.setAttribute('style', 'overflow-y: hidden;');
      this.setState({
        renderPortal: true
      }, function () {
        if (onBackdropClick) {
          _this2.onBackdropClickFnc();
        }
      });
    }
  }, {
    key: "onModalClose",
    value: function onModalClose() {
      var _this$props = this.props,
        onBackdropClick = _this$props.onBackdropClick,
        onExit = _this$props.onExit;
      if (onExit) {
        onExit();
      }
      if (onBackdropClick) {
        this.backdrop.removeEventListener('click', this.handleBackdropClick);
      }
      var modal = document.querySelector('.jui-modal');
      modal.remove();
      this.removeBodyOverflow();
      this.setState({
        renderPortal: false
      });
    }
  }, {
    key: "onBackdropClickFnc",
    value: function onBackdropClickFnc() {
      var _this3 = this;
      var onBackdropClick = this.props.onBackdropClick;
      this.backdrop = document.getElementById('backdrop');
      if (this.backdrop === null) return;
      this.backdrop.addEventListener('click', function (event) {
        return _this3.handleBackdropClick(event, onBackdropClick);
      });
    }
  }, {
    key: "createModalDiv",
    value: function createModalDiv() {
      var body = document.querySelector('body');
      var modal = document.createElement('div');
      modal.classList.add('jui-modal');
      body.insertBefore(modal, body.childNodes[0]);
    }
  }, {
    key: "removeBodyOverflow",
    value: function removeBodyOverflow() {
      var body = document.querySelector('body');
      body.removeAttribute('style');
    }
  }, {
    key: "handleBackdropClick",
    value: function handleBackdropClick(event, onBackdropClick) {
      if (event.target.id === 'backdrop') {
        this.removeBodyOverflow();
        onBackdropClick();
      }
    }
  }, {
    key: "closeModalFnc",
    value: function closeModalFnc(closeModal) {
      this.removeBodyOverflow();
      closeModal();
    }
  }, {
    key: "renderCloseButton",
    value: function renderCloseButton() {
      var _this4 = this;
      var _this$props2 = this.props,
        hideCloseButton = _this$props2.hideCloseButton,
        iconColor = _this$props2.iconColor,
        iconWidth = _this$props2.iconWidth,
        iconHeight = _this$props2.iconHeight,
        closeModal = _this$props2.closeModal,
        theme = _this$props2.theme;
      if (hideCloseButton) return null;
      return /*#__PURE__*/React.createElement(CloseButton, {
        "data-testid": "modal-close-button",
        "data-cy": "modal-close-button",
        theme: theme,
        onClick: function onClick() {
          return _this4.closeModalFnc(closeModal);
        }
      }, /*#__PURE__*/React.createElement(CloseIcon, {
        iconColor: iconColor,
        width: iconWidth,
        height: iconHeight
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        children = _this$props3.children,
        mobileFullScreen = _this$props3.mobileFullScreen,
        isOpen = _this$props3.isOpen,
        onBackdropClick = _this$props3.onBackdropClick,
        theme = _this$props3.theme,
        onClick = _this$props3.onClick,
        rest = _objectWithoutProperties(_this$props3, _excluded);
      var renderPortal = this.state.renderPortal;
      var shouldRender = isOpen && renderPortal;
      return /*#__PURE__*/React.createElement(React.Fragment, null, shouldRender && /*#__PURE__*/React.createElement(Portal, {
        selector: ".jui-modal"
      }, _ref, /*#__PURE__*/React.createElement(Backdrop, {
        theme: theme,
        id: "backdrop"
      }, /*#__PURE__*/React.createElement(ModalContainer, _extends({}, rest, {
        mobileFullScreen: mobileFullScreen,
        theme: theme,
        isOpen: isOpen
      }), this.renderCloseButton(), children))));
    }
  }]);
  return Modal;
}(React.Component);
export default withTheme(Modal);